import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const Hr = styled.hr`
  border: 0.5 solid #474747;
  width: 100%;
  margin: 20px 0;
`;
export const PreViewerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Customization = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
  background: #355B94;
  border-radius: 99px;
  width: fit-content;
  padding: 4px 10px;
  color: #fff;
  cursor: pointer;
  &:hover {
    background: #32568c;;
  }
`;
export const Select = styled.select<{
  selectedFont: string;
}>`
  color: #2c2c2c;
  font-size: 18px;
  border: 1px solid #c9c9c9;
  border-radius: 99px;
  font-family: ${({ selectedFont }) => selectedFont ? selectedFont : "Archivo-Regular" || "sans-serif"};
  height: 40px;
  padding: 0px 8px;
  width: 100%;
  cursor: pointer;
  &:focus {
    outline: none;
    border: 1px solid #355B94;
    border-radius: 99px;
  }
  &::placeholder {
    color: #47474790;
  }
  option {
    font-size:14px;
  }
`;
export const PersonalizeWrapper = styled.div`
  display: flex;

  justify-content: center;
  flex-direction: column;
  gap: 20px;
  font-weight: 600;
  > div {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    label {
      color: #474747;
    }
  }
`;
export const Label = styled.label`
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
export const ImageContainer = styled.div<{
  selectedFont: string;
}>`
  display: flex;
  background: transparent;
  align-items: center;
  justify-content: center;
  border: 2px dashed #474747;
  border-radius: 14px;
  min-height: 140px;
  padding: 10px;
  width: 100%;
  position: relative;

  p {
    white-space: nowrap;
    font-family: ${({ selectedFont }) => selectedFont || "sans-serif"};
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 10px;
  }
`;
